module.exports = __webpack_public_path__ + "img/video-25.1a3e0129.png";